import type { MutateOptions } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import useInvalidateOpportunityQueries from "app/pages/sales-intelligence/pages/opportunity-list/hooks/useInvalidateOpportunityQueries";
import { fetchWorkspacesThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import type { RemoveFromListParams } from "app/pages/sales-intelligence/sub-modules/opportunities/query/mutations/useRemoveFromListMutation";
import { useRemoveFromListMutation } from "app/pages/sales-intelligence/sub-modules/opportunities/query/mutations/useRemoveFromListMutation";

import type { FetchTopNLeadsDomainsParams } from "../queryFn/useFetchTopNLeadsDomains";
import { useFetchTopNLeadsDomains } from "../queryFn/useFetchTopNLeadsDomains";

type Params = Omit<RemoveFromListParams, "domains"> & FetchTopNLeadsDomainsParams;

type Options = Pick<MutateOptions<void, unknown, Params>, "onSuccess">;

export const useRemoveTopNLeadsFromListMutation = (leadsType: LeadsType, { onSuccess }: Options = {}) => {
    const invalidateOpportunitiesQueries = useInvalidateOpportunityQueries();
    const dispatch = useDispatch();

    const fetchTopNLeadsDomains = useFetchTopNLeadsDomains<Params>(leadsType);

    return useRemoveFromListMutation<Params>({
        fetchDomains: fetchTopNLeadsDomains,
        onSuccess(...params) {
            void invalidateOpportunitiesQueries(params[1].listParams.id);
            void dispatch(fetchWorkspacesThunk());

            onSuccess?.(...params);
        },
    });
};
